module.exports = __webpack_public_path__ + "static/img/aboutbanner12.5ac78dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutbanner12.jpg
// module id = ju59
// module chunks = 0